import { Enums } from "../thor.enums";
import { LOCALE } from "../thor.const";

import en from "../locale/en";
import es from "../locale/es";
import fr from "../locale/fr";
import it from "../locale/it";

const LANG: Enums.Locale[] = Object.values(Enums.Locale);

class LocaleProvider {
    public static $inject: string[] = [
        "$injector",
        "$translateProvider"
    ];

    public auctionDomain: string;

    private config;
    private language: Enums.Locale;

    constructor(
        $injector: ng.auto.IInjectorService,
        private $translateProvider: ng.translate.ITranslateProvider
    ) {
        // @ts-ignore
        this.config = $injector.get("configServiceProvider").$get();
        this.auctionDomain = this.config.auction.domain;
        this.language = this.getLanguage();

        const translations = this.getTranslations();
        const langFallback = [LOCALE];
        const langKeys = [];
        const langAliases = {};

        LANG.forEach((l: Enums.Locale) => {
            if (translations[l]) {
                $translateProvider.translations(l, translations[l]);
                langKeys.push(l);
                langAliases[`${l}_*`] = l;

                if (l === Enums.Locale.En) {
                    langFallback.unshift(l);
                }
            }
        });

        $translateProvider
            .registerAvailableLanguageKeys(langKeys, langAliases)
            .fallbackLanguage(langFallback)
            .use(this.language)
            .useLocalStorage()
            .usePostCompiling(true)
            // @todo safer sanitizer (keep only wanted tags & attrs)
            .useSanitizeValueStrategy("sceParameters")
            .useMessageFormatInterpolation()
            .addInterpolation("$translateMessageFormatInterpolation")
            .useMissingTranslationHandler("translateCustomHandlerFactory");
    }

    public $get() {
        return { language: this.language };
    }

    // check localStorage lang key, or client locale, or use default fr
    private getLanguage(): Enums.Locale {
        const localStorageKey = <Enums.Locale>localStorage.getItem(this.$translateProvider.storageKey());
        const clientLocale = <Enums.Locale>this.$translateProvider.resolveClientLocale();

        if (
            localStorageKey && !LANG.includes(localStorageKey) ||
            !clientLocale ||
            clientLocale && !LANG.includes(clientLocale)
        ) {
            return LOCALE;
        }

        return localStorageKey || clientLocale;
    }

    private getTranslations() {
        return {
            fr,
            es,
            en,
            it
        };
    }
}

angular
    .module("thor.core.locale.provider", [])
    .provider("locale", LocaleProvider);
